import { atomFamily, selectorFamily } from "recoil";

const contentsAnimatingState = atomFamily({
  key: 'contentsAnimatingState',
  default: selectorFamily({
    key: 'contentsAnimatingStateFamily',
    get: id => () => {
      return {[id]: false};
    }
  })
});

export const contentsAnimatingStateWithId = selectorFamily({
  key: 'contentsAnimatingStateWithId',
  get: id => ({get}) => get(contentsAnimatingState(id)),
  set: id => ({set}, newValue) => set(contentsAnimatingState(id), {[id]: newValue})
});

const contentsCurrentTimeState = atomFamily({
  key: 'contentsCurrentTimeState',
  default: selectorFamily({
    key: 'contentsCurrentTimeStateFamily',
    get: (id, value) => () => {
      return {[id]: value};
    }
  })
});

export const contentsCurrentTimeStateWidthId = selectorFamily({
  key: 'contentsCurrentTimeStateWidthId',
  get: id => ({get}) => get(contentsCurrentTimeState(id)),
  set: id => ({set}, newValue) => set(contentsCurrentTimeState(id), {[id]: newValue})
});
